<template>
  <div>
    <inventory product="KVKK" />
  </div>
</template>
<script>
import inventory from "./inventory";

export default {
  components: { inventory },
};
</script>
